import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Paper,
} from '@material-ui/core';
import {CheckBox, Create} from '@material-ui/icons';
import React from 'react';
import {Trans, useTranslation} from 'react-i18next';

import {IParty} from '../store/types';

interface IPropsDialog {
  open: boolean;
  min: number;
  max: number;
  party: IParty[];
  onClose: (action: string) => void;
}

const ConfirmVotingDialog: React.FC<IPropsDialog> = ({
  open,
  min,
  max,
  party,
  onClose,
}) => {
  const {t} = useTranslation();
  const handleCancel = () => {
    onClose('cancel');
  };

  const handleOk = () => {
    onClose('confirm');
  };

  const whitesCount: number = max - party.length;
  const whites =
    whitesCount > 0 && min !== max ? Array.from(Array(whitesCount).keys()) : [];

  const getTextChoices = () => {
    switch (party.length) {
      case 0:
        return (
          <span className="warnig-text">
            {t('confirmar-votacao.sem-escolhas-marcadas')}
          </span>
        );
      case 1:
        return <span>{t('confirmar-votacao.uma-escolha-marcada')}</span>;

      default:
        return (
          <Trans
            i18nKey="confirmar-votacao.voce-fez-x-escolhas"
            shouldUnescape={true}
            components={{b: <b />}}
            values={{
              characters: escape('<, >, &'),
              numeroDeEscolhas: party.length,
            }}
          />
        );
    }
  };

  const getWhiteTextChoices = () => {
    if (min !== 0) {
      return '';
    }

    switch (whitesCount) {
      case 0:
        return '';
      case 1:
        return <span>{t('confirmar-votacao.uma-escolha-em-branco')}</span>;
      default:
        return (
          <Trans
            i18nKey="confirmar-votacao.votando-em-branco-em-x-escolhas"
            shouldUnescape={true}
            components={{b: <b />}}
            values={{
              characters: escape('<, >, &'),
              numeroDeVotosEmBranco: whites.length,
            }}
          />
        );
    }
  };

  return (
    <Dialog
      aria-labelledby="simple-dialog-title"
      open={open}
      onClose={handleCancel}
      className="confirm-voting-dialog"
    >
      <DialogTitle>{t('confirmar-votacao.confirme-seu-voto')}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <div style={{display: 'flex', flexDirection: 'column'}}>
            <span>{getTextChoices()}</span>

            <span>{getWhiteTextChoices()}</span>

            <span>{t('confirmar-votacao.reveja-cedula-votacao')}</span>
          </div>
        </DialogContentText>
        {party.map(part => {
          return (
            <Paper key={part.id} className="white-box" elevation={3}>
              <CheckBox />
              <span>{part.name} </span>
            </Paper>
          );
        })}
        {whites.map(part => {
          return (
            <Paper key={part} className="white-box white-vote" elevation={3}>
              {t('confirmar-votacao.branco')}
            </Paper>
          );
        })}
        <DialogContentText>
          {t('confirmar-votacao.clique-corrigir-ou-confirmar')}
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button
          className={`button-default  full-width`}
          type="button"
          color="primary"
          variant="contained"
          onClick={handleCancel}
          startIcon={<Create />}
        >
          {t('geral.corrigir')}
        </Button>

        <Button
          className={`button-default btn-green  full-width`}
          type="button"
          color="primary"
          variant="contained"
          onClick={handleOk}
          startIcon={<CheckBox />}
        >
          {t('geral.confirmar')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmVotingDialog;



// WEBPACK FOOTER //
// ./src/features/election/components/ConfirmVotingDialog.tsx